import * as PowerBiEmbedConfigConstants from './PowerBiEmbedConfigConstants';

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    isPowerBIConfigDataFetching: false,
    isPowerBIConfigDataFetched: false,
    isPowerBIConfigDataFailed: false,
    workSpaceID: '',
    reportID: '',
    embedURL: '',
    accesToken: '',
    powerBIApiToken: ''
};

export default function PowerBiEmbedConfigReducer(state = initialState, action){

    switch(action.type) {

        case PowerBiEmbedConfigConstants.POWER_BI_EMBED_CONFIG_REQUEST:
            return assign({}, state, {
                isPowerBIConfigDataFetching : true,
               isPowerBIConfigDataFailed : false,
                workSpaceID :'',
                reportID:'',
                embedURL:'',
                accesToken:'',
                powerBIApiToken:''
            });
            break;

        case PowerBiEmbedConfigConstants.POWER_BI_EMBED_CONFIG_SUCCESS:
                                                      
            return assign({}, state, {
                isPowerBIConfigDataFetching : false,
                isPowerBIConfigDataFetched : true,
                isPowerBIConfigDataFailed : false,
                workSpaceID :action.newState.result.powerBiConfig.workSpaceID,
                reportID:action.newState.result.powerBiConfig.reportID,
                embedURL:action.newState.result.powerBiConfig.embedURL,
                accesToken:action.newState.result.powerBiConfig.accessToken,
                powerBIApiToken:action.newState.result.powerBiConfig.powerBIApiToken
            });
            break;

        case PowerBiEmbedConfigConstants.POWER_BI_EMBED_CONFIG_FAILURE:
            return assign({}, state, {
                isPowerBIConfigDataFetching : false,
                isPowerBIConfigDataFetched : false,
                isPowerBIConfigDataFailed : true,
                workSpaceID :'',
                reportID:'',
                embedURL:'',
                accesToken:'',
                powerBIApiToken:''
            });
            break;
        case PowerBiEmbedConfigConstants.RESET_POWER_BI_EMBED_CONFIG_STATE: {
            return assign({}, state, initialState);
        }
        default :
            return state;

    }

}